import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import TestReviewPlayer from '../components/test-prep/TestReviewPlayer';

export default function TestReviewPage() {
  const { domain, sessionId } = useParams();
  const navigate = useNavigate();

  const handleNavigate = (target) => {
    if (target === 'score_report') {
      navigate(`/tests/${domain}/report/${sessionId}`);
    } else if (target === 'test_list') {
      navigate(`/tests/${domain}`);
    }
  };

  return (
    <TestReviewPlayer
      scene={{
        session_id: sessionId,
        domain_id: domain,
        onNavigate: handleNavigate,
      }}
    />
  );
}
